import type { EmailActivity } from '@common/types/activities';
import { Box, Divider, Typography } from '@mui/material';
import QuoteItem from '../QuoteItem';
import ShowLessButton from '../ShowLessButton';
import { cleanHTML } from '../util';

interface Props {
    emailBody: EmailActivity['body'];
    isBodyExpanded: boolean;
    setIsBodyExpanded: (val: boolean) => void;
}

export default function QuoteEmailReminderBody({
    emailBody,
    isBodyExpanded,
    setIsBodyExpanded,
}: Props) {
    const isAlberta = emailBody.LegalFeesWithGst;
    return (
        <Box
            sx={{
                marginTop: '16px',
                wordWrap: 'break-word',
                overflowWrap: 'anywhere',
            }}
        >
            <Typography variant="h4" sx={{ marginBottom: '16px' }}>
                Quote request response
            </Typography>
            <Typography variant="body2" color="text.primary">
                Hello {emailBody?.ClientName},
            </Typography>
            <Typography variant="body2" color="text.primary">
                <div
                    dangerouslySetInnerHTML={{
                        __html: cleanHTML(emailBody?.EmailBodyIntroduction || ''),
                    }}
                ></div>
            </Typography>
            <Box
                sx={{
                    marginTop: '16px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px',
                }}
            >
                <QuoteItem
                    itemLabel={`Legal fee with ${isAlberta ? 'GST' : 'HST'}:`}
                    value={isAlberta ? emailBody?.LegalFeesWithGst : emailBody?.LegalFeesWithHst}
                />
                <QuoteItem
                    itemLabel={`Estimated disbursements with ${isAlberta ? 'GST' : 'HST'}:`}
                    value={
                        isAlberta ? emailBody?.DisbrusmentWithGst : emailBody?.DisbrusmentWithHst
                    }
                />
                {emailBody?.TitleInsuranceFees && (
                    <QuoteItem
                        itemLabel="Estimated title insurance fee:"
                        value={emailBody?.TitleInsuranceFees}
                    />
                )}
                {emailBody?.RegistrationFees && (
                    <QuoteItem
                        itemLabel="Estimated registration fees:"
                        value={emailBody?.RegistrationFees}
                    />
                )}
                {emailBody?.LandTransferTax && (
                    <QuoteItem itemLabel="Land transfer tax:" value={emailBody?.LandTransferTax} />
                )}
                {emailBody?.FirstTimeHomeBuyerRebate && (
                    <QuoteItem
                        itemLabel="First time home buyer rebate:"
                        value={emailBody?.FirstTimeHomeBuyerRebate}
                    />
                )}
                {emailBody?.NetLandTransferTax && (
                    <QuoteItem
                        itemLabel="Net Land Transfer Tax:"
                        value={emailBody?.NetLandTransferTax}
                    />
                )}
            </Box>
            <Divider sx={{ margin: '16px 0px' }} />
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                    justifyContent: 'space-between',
                }}
            >
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                    Quote total:
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 500, color: 'text.primary' }}>
                    {emailBody?.QuoteTotal}
                </Typography>
            </Box>
            <Typography variant="body2" sx={{ color: 'text.primary', marginTop: '16px' }}>
                <div
                    dangerouslySetInnerHTML={{
                        __html: cleanHTML(emailBody?.EmailBodyClosing || ''),
                    }}
                ></div>
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.primary', marginTop: '16px' }}>
                <div
                    dangerouslySetInnerHTML={{
                        __html: cleanHTML(emailBody?.EmailSignature || ''),
                    }}
                ></div>
            </Typography>
            <ShowLessButton
                isBodyExpanded={isBodyExpanded}
                bodyExpandedHandler={setIsBodyExpanded}
            />
        </Box>
    );
}
